export default "__VITE_ASSET__HvJznZag__"